/// <reference path="BaseField.ts" />

namespace MACRAIL.Forms.Fields {

export class Select extends BaseField {

    protected opts: SelectOptions;

    constructor (element: string | JQuery, opts: ObjectHash = {}) {
        super(element, opts);

        this.element.on('change', (e) => {
            let newValue = this.element.val();
            this.value = newValue;
        });
    }

    /**
     * Reset field back to default.
     */
    public reset() {
        super.reset();
        this.setValue(this.element.find('option:first-child').val());
        this.setDirty(false);
    }

    /**
     * Get the value for this field.
     *
     * Will convert -1 into undefined.
     */
    public getValue() {
        let value = this.element.val();

        if (value === '-1') {
            value = undefined;
        }

        return value;
    }
}

interface SelectOptions extends FieldOptions {
}

}
